// Parse a 2-letter US state code out of a Nielsen DMA name. Most DMA names
// follow "City, ST" or "City, ST (Suffix)"; some are city-only ("New York")
// or hyphenated ("San Francisco-Oakland-San Jose") and yield nothing — the
// staff editor picks manually in that case.
export function inferStateFromDmaName(name: string): string | null {
  const cleaned = name.replace(/\([^)]*\)/g, '').trim();
  const parts = cleaned.split(',').map((p) => p.trim()).filter(Boolean);
  const tail = parts[parts.length - 1] ?? '';
  return /^[A-Z]{2}$/.test(tail) ? tail : null;
}
